import axios from "axios";
import { toastController } from "@ionic/core";
import { api_s2 } from "../config";

// Base url for S2 API (pymble-apis)
axios.defaults.baseURL = api_s2.baseURL;

/**
 * Our standard http service for http requests
 */
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const expectedErr =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedErr) {
      console.error("httpService error:", error);
      const toast = await toastController.create({
        color: "danger",
        duration: 6000,
        message:
          "Oops. Something went wrong. Please try reloading or contact IT Services.",
        position: "middle",
      });

      await toast.present();
    }

    const notAuthorisedErr = error.response && error.response.status === 401;

    if (notAuthorisedErr) {
      const toast = await toastController.create({
        color: "warning",
        duration: 4000,
        message: "Sorry, request not authorised.",
        position: "middle",
      });

      await toast.present();
    }

    return Promise.reject(error);
  }
);

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  head: axios.head,
  request: axios.request,
};

export default httpService;
